import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideClientHydration, withEventReplay, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { API_TRANSPORT, createApiTransport } from '@common/api';
import { provideRtStorage } from '@rt-tools/core';
import { provideRtIcons } from '@rt-tools/ui-kit-v2';
import { provideAnalytics } from '@stair-craft/common/analytics';
import { SITE_ORIGIN, provideSiteKitLabels } from '@stair-craft/common/util';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZonelessChangeDetection(),
        provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
        provideBrowserGlobalErrorListeners(),
        provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })),
        provideAnalytics(),

        // The kit storage: the home hero keeps its chosen video variant there for the tab (session storage).
        provideRtStorage(),

        // Набор интерфейса: значки и подписи. Значки едут спрайтом с адреса `/icons` — его кладёт
        // сборка приложения, и без этого разметка набора верна, а на экране пусто.
        provideRtIcons(),
        provideSiteKitLabels(),

        // Сервер зовётся путём своего домена, а не адресом сервера: список источников сервера
        // открыт одной админке, и вызов с домена сайта он бы не пустил. Обратно на сервер путь
        // заворачивает тот, кто стоит перед сайтом.
        { provide: API_TRANSPORT, useValue: createApiTransport('/chat') },
        { provide: SITE_ORIGIN, useValue: 'https://goldencalc.by' },
    ],
};
